import { DateValue } from '@internationalized/date';
import { z } from 'zod';

export const reviewSchema = z.object({
  googlePlaceId: z.string({
    required_error: 'validation.place-required',
  }),
  foodId: z.number().optional(),
  drinkId: z.number().optional(),
  reviewText: z.string().min(80, 'validation.review-min-length'),
  overallRating: z.number({
    required_error: 'validation.rating-required',
  }).min(0).max(10),
  cost: z.number({
    required_error: 'validation.cost-positive',
  }).min(0),
  visitedAt: z.custom<DateValue>().nullable().optional(),
  type: z.enum(['food', 'drink'], {
    required_error: 'validation.type-required',
  }),
}).refine((data) => {
  if (data.type === 'food') {
    return !!data.foodId;
  }
  return true;
}, {
  message: 'validation.food-required',
  path: ['foodId'],
}).refine((data) => {
  if (data.type === 'drink') {
    return !!data.drinkId;
  }
  return true;
}, {
  message: 'validation.drink-required',
  path: ['drinkId'],
});

export type ReviewFormData = z.infer<typeof reviewSchema>; 